export class AddWeightResponse {
  constructor(public success: boolean, public weightlog: Weightlog) {}
}

export class UpdateWeightResponse {
  constructor(public success: boolean) {}
}

export class GetWeightResponse {
  constructor(public success: boolean, public weightlogs: Weightlog[]) {}
}

export class Weightlog {
  constructor(public weight: number, public date: number, public _id: string) {}
}

export class Weightlogs {
  constructor(public weightlogs: Weightlog[], public updatedAt: string) {}
}
